import React, { Component, Fragment } from 'react';
import SideNav from '../../../components/SideNav';
import Grid from '@material-ui/core/Grid';
import './style.css';
import api from './../../../services/api';

import {password} from '../../../services/api';
let apiPassword = new password();

export default class TelaPassword extends Component {

    representante_id = this.props.match.params.id;

    //Estados da classe
    constructor(props) {
        super(props);
        this.state = {
          password: "",
          confirmPassword: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }

    //Metodo handle change do input
    handleChange = evt => {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    //Metodo handle submit do button
    //api.post(`/professional/)`

    handleSubmit = event => {
        event.preventDefault();

        const aux = {
            confirmPassword: this.state.confirmPassword
        }

        const data = {
            password: this.state.password            
        }

        // Validação de senha
        if (data.password !== aux.confirmPassword) {
            alert("As senhas inseridas não são iguais!");
        } else {
            // make API call
            // console.log("Data do input: " +data.password + " " + aux.confirmPassword);
            //console.log(medico_id);
            //api.patch(`/password/agent/${this.representante_id}`, data)
            // let toJson={password: this.state.password }
            apiPassword.editAgentPassword(data, this.representante_id)
            .then(res =>{ 
                //console.log(res);
                //console.log(res.data);
                alert("Sua senha foi alterada com sucesso!");
            })
        }

    }

    
    //Render method
    render(){
        return(
            
            <Fragment>
                <SideNav />
               
                <div className="bg-fp-main">
                    <h1 class-name="fonte-deafult">Redefinição de Senha</h1>
                </div>

                <br></br>

                <Grid container spacing={5} direction="row" justify="center" alignItems="center" style={{marginTop: '200px'}}>
                    <Grid item xs={12} align="center">
                        <h2 className="color-destaque">Insira uma nova senha para acesso</h2>
                        <hr className="line"></hr>
                        <br></br>

                        <form onSubmit={this.handleSubmit} id="forms-OG-Login">
                            <input onChange={this.handleChange} type="password" name="password" placeholder="Digite a nova senha:" id="OG-Login" />
                            <input onChange={this.handleChange} type="password" name="confirmPassword" placeholder="Confirmar senha inserida:" id="OG-Login" />
                            <button  onClick={() => this.handleSubmit} id="OG-Login">Redefinir Senha</button>
                        </form>
                    </Grid>
                </Grid>
            </Fragment>
        )
    }
}